import { Component, Input, OnInit } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import {
    FrequencyPeriod,
    getAnnualFrequencyPeriods,
    getMonthlyFrequencyPeriods,
    getQuarterlyFrequencyPeriods,
    getSemiAnnualFrequencyPeriods,
    getWeeklyFrequencyPeriods,
} from '@app/functions';
import { Template } from '@app/models/performance/template.model';
import { BaseForm } from '@forms/base.form';
import { Review } from '@models/performance/review.model';

const DATE_FORMATS = {
    parse: {
        dateInput: 'MMM DD, YYYY',
    },
    display: {
        dateInput: 'MMM DD, YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'app-form-bulk-review-details',
    templateUrl: './bulk-review-details.template.html',
    styles: [
        `
            .template-option {
                display: flex;
                justify-content: space-between;
                color: inherit;

                > span {
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        `,
    ],
    providers: [{ provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS }],
})
export class BulkReviewDetailsForm extends BaseForm implements OnInit {
    @Input() review: Review;
    @Input() templates: Template[] = [];

    reviewPeriods: { [key: string]: FrequencyPeriod[] } = {
        weekly: [],
        monthly: [],
        quarterly: [],
        semiannually: [],
        annually: [],
    };

    hasPerformanceModuleSplit = false;
    isLoading = true;
    selectedReviewPeriod = null;
    searchValue = '';
    filteredTemplates: Template[] = [];

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.setReviewPeriods();
    }

    filterTemplates(searchValue: string | number): void {
        if (typeof searchValue === 'number') {
            this.filteredTemplates = this.templates.filter((template) => template.id === searchValue);
            return;
        }

        this.filteredTemplates = this.templates.filter((template) =>
            template.name.toLowerCase().includes(searchValue.toLowerCase())
        );
    }

    onOptionSelected(event: MatAutocompleteSelectedEvent): void {
        const selectedTemplate = this.templates.filter((template) => template.id === event.option.value)[0];
        this.searchValue = selectedTemplate.name;
        this.review.templateId = event.option.value;
    }

    setReviewPeriods(): void {
        this.reviewPeriods['weekly'] = getWeeklyFrequencyPeriods();
        this.reviewPeriods['monthly'] = getMonthlyFrequencyPeriods();
        this.reviewPeriods['quarterly'] = getQuarterlyFrequencyPeriods();
        this.reviewPeriods['semiannually'] = getSemiAnnualFrequencyPeriods();
        this.reviewPeriods['annually'] = getAnnualFrequencyPeriods();
    }

    reviewPeriodSelection(reviewPeriodSelection: string): void {
        if (reviewPeriodSelection === undefined) {
            return;
        }

        if (reviewPeriodSelection === 'custom') {
            this.review.periodStart = null;
            this.review.periodEnd = null;

            return;
        }

        const selectedReviewPeriod = this.reviewPeriods[this.review.reoccuring][reviewPeriodSelection] ?? null;

        if (!selectedReviewPeriod) {
            return;
        }

        this.review.periodStart = selectedReviewPeriod.start;
        this.review.periodEnd = selectedReviewPeriod.end;
    }

    clearSelectedReviewPeriod(): void {
        this.selectedReviewPeriod = null;
        this.review.periodStart = null;
        this.review.periodEnd = null;
    }
}
